import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import ItemManagement from '../../../outlet/outlet-container';
import HubDetailsInfo from './HubDetailsInfo';
import ProductDetailsInfo from './ProductDetailsInfo.jsx';
import { ToastSuccess } from '../../../component/toast-notification.js';
import { mainProduct, productActiveStatus, productDeleteStatus } from '../../../api/apiService';
import { loader } from '../../../Actions';

export default function SingleDeHubDetails(props) {
  const hubId = new URLSearchParams(props.location.search).get('hubId'); 
  return (
    <ItemManagement demoPathName="/outlets" outletPathName="Outlet / Resturent" fontPathName="Outlet item">
      <HubDetailsInfo hubId={hubId} />
      <ProductDetailsInfo hubId={hubId}/>
    </ItemManagement>
  );
}
